import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import AIChatInterface from "../components/AIChatInterface";

const AIChatPage = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col h-screen bg-white">
      <div className="flex items-center gap-3 px-4 py-3 border-b border-gray-200">
        <button
          onClick={() => navigate(-1)}
          className="flex items-center justify-center w-9 h-9 rounded-full transition-colors hover:bg-gray-100"
          aria-label="Go back"
        >
          <ArrowLeft className="w-5 h-5 text-gray-700" />
        </button>
        <div className="flex items-center gap-2">
          <div className="flex items-center justify-center w-8 h-8 rounded-full bg-gradient-to-r from-primary to-orange-500">
            <span className="text-sm">🤖</span>
          </div>
          <div>
            <h1 className="text-base font-semibold text-gray-900">LearnHub Assistant</h1>
            <p className="text-xs text-gray-500">AI-powered learning help</p>
          </div>
        </div>
      </div>
      <div className="flex-1 overflow-hidden w-full max-w-3xl mx-auto">
        <AIChatInterface isFullPage />
      </div>
    </div>
  );
};

export default AIChatPage;
